import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    class: "d-flex flex-column cms-editor-dialog",
    style: { "min-height": "600px" }
};
const _hoisted_2 = { class: "p-2 w-100 h-100 bg-white" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_cms_form_page = _resolveComponent("g-cms-form-page");
    const _component_DxTabPanel = _resolveComponent("DxTabPanel");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, {
        title: 'Account ' + _ctx.accountId,
        "class-content": "content__for-sticky"
    }, {
        "modal-footer": _withCtx(() => [
            _createVNode(_component_g_button, {
                text: _ctx.$tc('shared.Text.Close'),
                onClick: _ctx.currentWindow.close,
                type: "normal",
                class: "w-120-px"
            }, null, 8, ["text", "onClick"])
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_DxTabPanel, {
                    "data-source": _ctx._schema.pages,
                    "item-title-template": "title",
                    "item-template": "itemTemplate",
                    height: "100%"
                }, {
                    title: _withCtx(({ data: view }) => [
                        _createElementVNode("span", null, _toDisplayString(view.label), 1)
                    ]),
                    itemTemplate: _withCtx(({ data: view }) => [
                        _createElementVNode("div", _hoisted_2, [
                            (view.formName)
                                ? (_openBlock(), _createBlock(_component_g_cms_form_page, {
                                    key: 0,
                                    "form-name": view.formName
                                }, null, 8, ["form-name"]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 1
                }, 8, ["data-source"])
            ])
        ]),
        _: 1
    }, 8, ["title"]));
}
